/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { displayInfoStyles } from "./styles";
import { Status, DisplayInfoProps, actionType } from "./interface";
import { LinkButton } from "../LinkButton";
import { useIsMobile, useIsTab } from "../../hooks/useIsMobile";
import { renderImageAsPerStatus } from "../../utils/helpers";

export const DisplayInfo: React.FunctionComponent<DisplayInfoProps> = (
  props
) => {
  const { status, className } = props;
  const isMobile = useIsMobile();
  const isTablet = useIsTab();

  const renderArrayString = (data: Array<string>) => {
    return data.map((item, key) => {
      return <span key={key}>{item}</span>;
    });
  };

  const handleActionLinkClick = (actionLinkObj?: actionType) => {
    if (actionLinkObj && actionLinkObj.type === "url") {
      window.open(actionLinkObj.action, "_blank");
    }
  };

  return (
    <div
      className={`info-container ${className ? className : ""}`}
      css={displayInfoStyles(
        status || Status.inProgress,
        isMobile || isTablet ? true : false
      )}
    >
      {props.header && (
        <div className="info-header">
          {props.header.heading && <span>{props.header.heading}</span>}
          {props.header.actionLink && (
            <LinkButton>{props.header.actionLink.text}</LinkButton>
          )}
        </div>
      )}
      <div className="info-box">
        <div className="info-box-data">
          <span className="title">
            {status !== Status.default && (
              <img
                className="info-box-icon"
                src={renderImageAsPerStatus(status || Status.inProgress)}
                alt={status}
              />
            )}
            <span className="title-array">
              {renderArrayString(props.title)}
            </span>
            {props.actionLink && (
              <LinkButton
                className="title-action-link"
                onClick={() => handleActionLinkClick(props.actionLink)}
              >
                {props.actionLink.text}
              </LinkButton>
            )}
          </span>
          {props.description && (
            <span className="description">
              {renderArrayString(props.description)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
